import React from 'react';
import ToastContainer from 'react-bootstrap/ToastContainer';
import Toast from 'react-bootstrap/Toast';
import CloseButton from 'react-bootstrap/CloseButton';

import { EVM_BLOCKCHAINS, TELOS_EXPLORER_URL, getEVMChainSlug } from '../config';
import './ToastMessage.css';

function Error(props) {
    return (
        <ToastContainer className="p-4" position="middle-center">
            <Toast className="error" show={props.isShown} onClose={props.onAutoClosed} delay={3500} autohide>
                <Toast.Header closeButton={false}>
                    <h5 className="toast-header-title error">Error</h5>
                </Toast.Header>

                <Toast.Body>{props.message}</Toast.Body>
           </Toast>
       </ToastContainer>
   );
};

function TransactionSigned(props) {
    if (!props.trxHash) {
        return;
    }

    const trxDetailsURL = new URL('transaction/' + props.trxHash, TELOS_EXPLORER_URL).toString();
    
    return (
        <ToastContainer className="p-4" position="middle-center">
            <Toast className="success" show={props.isShown} onClose={props.onAutoClosed} delay={3500} autohide>
                <Toast.Header closeButton={false}>
                    <h5 className="toast-header-title success">Success!</h5>
                </Toast.Header>

                <Toast.Body>
                    Transaction signed successfully! See on <a href={trxDetailsURL} target="_blank" rel="noreferrer">{TELOS_EXPLORER_URL.host}</a>
                </Toast.Body>
           </Toast>
       </ToastContainer>
   );
};

function EVMTokenDeployed(props) {
    const {contractAddress, trxHash, chainID} = props;

    if (!chainID) {
        return;
    }
    
    const evmChainSlug = getEVMChainSlug(chainID);
    const explorerURL = EVM_BLOCKCHAINS[evmChainSlug].explorerURL;
    const trxDetailsURL = new URL('tx/' + trxHash, explorerURL).toString();
    
    return (
        <ToastContainer className="p-4" position="middle-center">
            <Toast className="success" show={props.isShown}>
                <Toast.Header closeButton={false}>
                    <h5 className="toast-header-title success me-auto">Token Deployed!</h5>

                    <div data-bs-theme="dark">
                        <CloseButton onClick={props.onCloseClicked}/>
                    </div>
                </Toast.Header>

                <Toast.Body>
                    Your token has been deployed! See on <a href={trxDetailsURL} target="_blank" rel="noreferrer">{explorerURL.host}</a> and don't forget your token's address:<br/><br/><i>{contractAddress}</i>
                </Toast.Body>
           </Toast>
       </ToastContainer>
   );
};

const ToastMessageTypes = {Error, TransactionSigned, EVMTokenDeployed};
export default ToastMessageTypes;
